<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Ref/Consult/Assessment-{{ organ }}-EMR Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="transplantProgram"
              class="transplantProgram"
              disabled
              label="Transplant Program"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="recipientCoordinator"
              class="transplantProgram mandatory-field"
              disabled
              label="Recipient Coordinator "
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="primaryDiagnosis"
              class="primaryDiagnosis mandatory-field"
              disabled
              label="Primary Diagnosis"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-5">
            <ADSTextInput
              v-model="secondaryDiagnosis"
              class="primaryDiagnosis"
              disabled
              label="Secondary Diagnosis"
            />
          </div>
        </div>
        <hr class="lineBreak">
      <br>
        <span class="fieldName"> &nbsp; &nbsp;Referring Physician Details </span>
     <br><br>

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="referringOrganizationName"
              class="mandatory-field referringOrganizationName"
              disabled
              label="Referring Organization Name"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="referringOrganizationType"
              class="mandatory-field"
              disabled
              label="Referring Organization Type"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="referringHealthCareProfessionalType"
              class="mandatory-field referringHealthCareProfessionalType"
              disabled
              label="Referring Health Care Professional Type"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="firstName"
              class="mandatory-field"
              disabled
              label="First Name"
            />
          </div>

          <div class="col-2">
            <ADSTextInput
              v-model="lastName"
              class="mandatory-field"
              disabled
              label="Last Name"
            />
          </div>
          </div>


        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="address"
              class="address mandatory-field"
              disabled
              label="Office Street Address"
            />
          </div>
        </div>


        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="city"
              class="mandatory-field"
              disabled
              label="City"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="state"
              class="mandatory-field"
              disabled
              label="Province/State"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="postalCode"
              class="mandatory-field"
              disabled
              label="Postal Code"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="country"
              class="mandatory-field"
              disabled
              label="Country"
            />
          </div>
        </div>
        <hr class="lineBreak">

        <div class="row">
          <div class="col-4">
            <ADSTextInput
              v-model="referralDecision"
              disabled
              class="referralDecision mandatory-field"
              label="Referral Decision"
            />
          </div>
        </div>
       
        <div class="row">

          <div class="col-2">
            <ADSTextInput
              v-model="referralReceivedDate"
              class="mandatory-field"
              disabled
              label="Referral Received Date"
            />
          </div>


          <div class="col-2">
            <ADSTextInput
              v-model="referralDecisionDate"
              disabled
              class="mandatory-field"
              label="Referral Decision Date "
            />
          </div>
        </div>

     

        <div
          v-if="referralDecision?.toLowerCase() === 'referral declined' || referralDecision?.toLowerCase() === 'referral cancelled'"
          class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="referralDecisionReason"
              class="referralDecisionReason mandatory-field"
              disabled
              label="Referral Decision Reason"
            />
          </div>
        </div>

        <br>
        <hr class="lineBreak">
        <div class="row">
          <div class="col-2" v-if="consultationDecision?.toLowerCase() === 'consultation completed'">
            <ADSTextInput
              v-model="consultationDate"
              disabled
              class="mandatory-field"
              label="Consultation Date"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="consultationDecision"
              disabled
              class="mandatory-field consultationDecision"
              label="Consultation Decision"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2" v-if="consultationDecision?.toLowerCase() === 'consultation cancelled'">
            <ADSTextInput
              v-model="reasonCancelled"
              disabled
              label="Reason (for Cancelled)"
            />
          </div>

          <div v-if="consultationDecision?.toLowerCase() === 'consultation cancelled'"
               class="col-2">
            <ADSTextInput
              v-model="consultationCancelledDate"
              disabled
              label="Consultation Cancelled Date"
            />
          </div>

          <div class="col-2" v-if="consultationDecision?.toLowerCase() === 'consultation delayed'">
            <ADSTextInput
              v-model="reasonDelayed"
              disabled
              label="Reason (for Delayed)"
              class="reasonDelayed"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-2" v-if="consultationDecision?.toLowerCase() === 'consultation delayed'">
            <ADSTextInput
              v-model="consultationDelayStartDate"
              disabled
              label="Consultation Delay Start Date"
            />
          </div>

          <div class="col-2" v-if="consultationDecision?.toLowerCase() === 'consultation delayed'">
            <ADSTextInput
              v-model="consultationDelayEndDate"
              disabled
              label="Consultation Delay End Date"
            />
          </div>
          <div class="col-3">
            <ADSTextInput
              v-model="consultationComments"
              class="consultationComments"
              disabled
              label="Consultation Comments"
            />
          </div>
        </div>
        <br>
        <hr class="lineBreak">

        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="assessmentDate"
              class="mandatory-field"
              disabled
              label="Assessment Date"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="assessmentDecision"
              class="assessmentDecision mandatory-field"
              disabled
              label="Assessment Decision"
            />
          </div>
        </div>


        <div class="row">
          <div class="col-3" v-if="assessmentDecision?.toLowerCase() === 'assessment cancelled'">
            <ADSTextInput
              v-model="reasonAssessmentCancelled"
              class="reasonAssessmentCancelled"
              disabled
              label="Reason (for Assessment Cancelled)"
            />
          </div>

          <div class="col-3" v-if="assessmentDecision?.toLowerCase() === 'recipient not eligible for transplant'">
            <ADSTextInput
              v-model="reasonRecipientNotEligible"
              class="reasonRecipientNotEligible"
              disabled
              label="Reason (for Decision for Recipient not Eligible)"
            />
          </div>

          <div class="col-3" v-if="assessmentDecision?.toLowerCase() === 'further treatment/testing required'">
            <ADSTextInput
              v-model="reasonFurtherTreatment"
              class="reasonRecipientNotEligible"
              disabled
              label="Reason (for Further Treatment or Further Testing Required)"
            />
          </div>
        </div>

        <div class="row" >
          <div class="col-4" v-if="assessmentDecision?.toLowerCase() === 'further treatment/testing required'">
            <ADSTextInput
              v-model="other"
              class="other"
              disabled
              label="Other"
            />
          </div>

          <div class="col-4" v-if="assessmentDecision?.toLowerCase() === 'recipient not eligible for transplant'">
            <ADSTextInput
              v-model="absoluteContraindication"
              disabled
              label="Absolute Contraindications"
              class="relativeContraindication"
            />
          </div>

          <div class="col-3" v-if="assessmentDecision?.toLowerCase() === 'recipient not eligible for transplant'
          && ( organ !== 'Liver' && organ !== 'Intestine' )">
            <ADSTextInput
              v-model="relativeContraindication"
              class="relativeContraindication"
              disabled
              label="Relative Contraindications"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <ADSTextInput
              v-model="comments"
              class="comments"
              disabled
              label="Comments"
            />
          </div>
        <!-- <div class="col-3">
          <div class="fieldName">
            Comments
          </div>
          <input
            v-model="comments"
            class="inputDisplaycomments"
            disabled
          >
        </div>  -->
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';


export default {
  name: "ReferralConsultationSectionDetails",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    organ: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      transplantProgram: this.getTransplantProgram( this.patientBundle, this.organ ),
      recipientCoordinator: this.getRecipientCoordinator( this.patientBundle, this.organ ),
      referralReceivedDate: this.getReferralReceivedDate( this.patientBundle, this.organ ),
      referralDecisionDate: this.getReferralDecisionDate( this.patientBundle, this.organ ),
      referralDecision: this.getReferralDecision( this.patientBundle, this.organ ),
      referralDecisionReason: this.getReferralDecisionReason( this.patientBundle, this.organ ),
      referralDecisionComments: this.getReferralDecisionComments( this.patientBundle, this.organ ),
      primaryDiagnosis: this.getPrimaryDiagnosis( this.patientBundle, this.organ ),
      secondaryDiagnosis: this.getSecondaryDiagnosis( this.patientBundle, this.organ ),
      primaryDiagnosisDate: this.getPrimaryDiagnosisDate( this.patientBundle, this.organ ),
      referringOrganizationName: this.getReferringOrganizationName( this.patientBundle, this.organ ),
      referringOrganizationType: this.getReferringOrganizationType( this.patientBundle, this.organ ),
      otherOrganizationType: this.getOtherOrganizationType( this.patientBundle, this.organ ),
      referringHealthCareProfessionalType: this.getReferringHealthCareProfessionalType( this.patientBundle, this.organ ),
      consultationDate: this.getConsultationDate( this.patientBundle, this.organ ),
      consultationDecision: this.getConsultationDecision( this.patientBundle, this.organ ),
      reasonCancelled: this.getReasonCancelled( this.patientBundle, this.organ ),
      consultationCancelledDate: this.getConsultationCancelledDate( this.patientBundle, this.organ ),
      reasonDelayed: this.getReasonDelayed( this.patientBundle, this.organ ),
      consultationDelayStartDate: this.getConsultationDelayStartDate( this.patientBundle, this.organ ),
      consultationDelayEndDate: this.getConsultationDelayEndDate( this.patientBundle, this.organ ),
      consultationComments: this.getConsultationComments( this.patientBundle, this.organ ),
      assessmentDate: this.getAssessmentDate( this.patientBundle, this.organ ),
      assessmentDecision: this.getAssessmenDecision( this.patientBundle, this.organ ),
      reasonAssessmentCancelled: this.getReasonAssessmentCancelled( this.patientBundle, this.organ ),
      reasonRecipientNotEligible: this.getReasonRecipientNotEligible( this.patientBundle, this.organ ),
      reasonFurtherTreatment: this.getReasonFurtherTreatment( this.patientBundle, this.organ ),
      other: this.getOther( this.patientBundle, this.organ ),
      absoluteContraindication: this.getAbsoluteContraindication( this.patientBundle, this.organ ),
      relativeContraindication: this.getRelativeContraindication( this.patientBundle, this.organ ),
      comments: this.getComments( this.patientBundle, this.organ ),
      careTeamID: this.getCareTeamID( this.patientBundle, this.organ ),
      firstName: this.getFirstName( this.patientBundle, this.organ ),
      lastName: this.getLastName( this.patientBundle, this.organ ),
      address: this.getAddress( this.patientBundle, this.organ ),
      city: this.getCity( this.patientBundle, this.organ ),
      country: this.getCountry( this.patientBundle, this.organ ),
      postalCode: this.getPostalCode( this.patientBundle, this.organ ),
      state: this.getState( this.patientBundle, this.organ ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getTransplantProgram( patientBundle ) {
      let episodeOfCare = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' ) );
      if( episodeOfCare && episodeOfCare[ 0 ] && episodeOfCare[ 0 ][ 0 ] ) {
        for( let item of episodeOfCare[ 0 ][ 0 ]?.resource?.extension ) {
             if( item.url?.includes( "transplant-center" ) ) {
              return item.valueString;
             }
        
      }
      }
    },
    getRecipientCoordinator( patientBundle ) {
      let episodeOfCare = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' ) );
      if( episodeOfCare && episodeOfCare[ 0 ] && episodeOfCare[ 0 ][ 0 ] ) {
        for( let item of episodeOfCare[ 0 ][ 0 ]?.resource?.extension ) {
             if( item.url?.includes( "transplant-organ-coordinator" ) ) {
              let coordinator = item.extension.filter( ( n ) => ( n.url === 'coordinator' ) );
              if( coordinator && coordinator[ 0 ] )
              return _.get( coordinator[0], 'valueReference.display' )
             }
        
      }
      }
    },
    getCareTeamID( patientBundle ) {
      let episodeOfCare = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' ) );
      if( episodeOfCare && episodeOfCare[ 0 ] && episodeOfCare[ 0 ][ 0 ] ) {
       return _.get( episodeOfCare[ 0 ][ 0 ], 'resource.team[0].reference' ) .replace( 'CareTeam/', '' );
      }
    },
    getReferralReceivedDate( patientBundle ) {
      let episodeOfCares = patientBundle.entries.filter( ( n ) => (
        _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' 
      ) );
      if ( !( episodeOfCares && episodeOfCares[ 0 ] ) ) {
        return;
      }
      const episodeOfCare = episodeOfCares[0].filter( ( n ) => ( _.get( n, 'resource.id' ) === patientBundle.episode_id ) );
      if ( !( episodeOfCare ) ) {
        return;
      }
      if( episodeOfCare && episodeOfCare[ 0 ] ) {
        for( let item of episodeOfCare[ 0 ]?.resource?.extension ) {
             if( item.url?.includes( "transplant-event-referral-date" ) ) {
              return item.valueDate;
             }
      }
      }
    },
    getReferralDecisionDate( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let referralDecisionDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4113' : 'UHN#3985' ) 
        && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referralDecisionDate && referralDecisionDate[ 0 ] ) {
        return _.get( referralDecisionDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getReferralDecision( patientBundle, organ ) {
      const smartDataCode = organ === 'Pancreas' ? 'UHN#4112' : 'UHN#3973';
      const observations = patientBundle.entries.filter(
        ( entry ) =>
          _.get( entry[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( entry[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      if ( !observations.length ) return null;

      const referralDecision = observations[0].find(
        ( entry ) =>
          _.get( entry, 'resource.code.coding[0].code' ) === smartDataCode &&
          _.get( entry, 'resource.focus[0].reference', '' ).includes( patientBundle.episode_id )
      );
      return _.get( referralDecision, 'resource.component[0].valueString', null );
    },
    getReferralDecisionReason( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let referralDecisionReason = observation[ 0 ].filter( ( n ) => ( ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4114' : 'UHN#3975' ) || 
        _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4115' : 'UHN#3976' ) ) 
        && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
        if( referralDecisionReason && referralDecisionReason[ 0 ] ) {
        return _.get( referralDecisionReason[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReferralDecisionComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let referralDecisionComments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#323' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referralDecisionComments && referralDecisionComments[ 0 ] ) {
        return _.get( referralDecisionComments[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getPrimaryDiagnosis( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let primaryDiagnosis = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4109' : 'UHN#3971' ) && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( primaryDiagnosis && primaryDiagnosis[ 0 ]?.resource?.code?.text ) {
        return _.get( primaryDiagnosis[0], 'resource.component[0].valueCodeableConcept.text' );
      } 
      }
    },
    getSecondaryDiagnosis( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let primaryDiagnosis = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4111' : 'UHN#3984' ) && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( primaryDiagnosis && primaryDiagnosis[ 0 ]?.resource?.code?.text ) {
        return _.get( primaryDiagnosis[0], 'resource.component[0].valueCodeableConcept.text' );
      } 
      }
    },
    getPrimaryDiagnosisDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let primaryDiagnosis = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#338' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( primaryDiagnosis && primaryDiagnosis[ 0 ] ) {
        return _.get( primaryDiagnosis[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getReferringOrganizationName( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let referringOrganizationName = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3555' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referringOrganizationName && referringOrganizationName[ 0 ] ) {
        return _.get( referringOrganizationName[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReferringOrganizationType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let referringOrganizationName = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3556' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referringOrganizationName && referringOrganizationName[ 0 ] ) {
        return _.get( referringOrganizationName[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getOtherOrganizationType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let otherOrganizationType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#278' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( otherOrganizationType && otherOrganizationType[ 0 ] ) {
        return _.get( otherOrganizationType[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReferringHealthCareProfessionalType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let referringHealthCareProfessionalType = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3604' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( referringHealthCareProfessionalType && referringHealthCareProfessionalType[ 0 ] ) {
        return _.get( referringHealthCareProfessionalType[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getConsultationDate( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let consultationDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4117' : 'UHN#3558' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDate && consultationDate[ 0 ] ) {
        return _.get( consultationDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getConsultationDecision( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) )
      if( observation && observation[ 0 ] ) {
      let consultationDecision = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4116' : 'UHN#3559' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDecision && consultationDecision[ 0 ] ) {
        return _.get( consultationDecision[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonCancelled( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonCancelled = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4118' : 'UHN#3560' )  
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonCancelled && reasonCancelled[ 0 ] ) {
        return _.get( reasonCancelled[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getConsultationCancelledDate( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let consultationCancelledDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4269' : 'UHN#4268' )  
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationCancelledDate && consultationCancelledDate[ 0 ] ) {
        return _.get( consultationCancelledDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getReasonDelayed( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonDelayed = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4119' : 'UHN#3561' )  
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonDelayed && reasonDelayed[ 0 ] ) {
        return _.get( reasonDelayed[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getConsultationDelayStartDate( patientBundle, organ ) {  
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let consultationDelayStartDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4120' : 'UHN#3562' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDelayStartDate && consultationDelayStartDate[ 0 ] ) {
        return _.get( consultationDelayStartDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getConsultationDelayEndDate( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let consultationDelayEndDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4121' : 'UHN#3563' )
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationDelayEndDate && consultationDelayEndDate[ 0 ] ) {
        return _.get( consultationDelayEndDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getConsultationComments( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let consultationComments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4122' : 'UHN#3564' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( consultationComments && consultationComments[ 0 ] ) {
        return _.get( consultationComments[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getAssessmentDate( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let assessmentDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4103' : 'UHN#3986' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( assessmentDate && assessmentDate[ 0 ]?.resource?.code?.text ) {
        return _.get( assessmentDate[0], 'resource.component[0].valueDateTime' );
      } 
      }
    },
    getAssessmenDecision( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let assessmentDecision = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4104' : 'UHN#3987' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( assessmentDecision && assessmentDecision[ 0 ] ) {
        return _.get( assessmentDecision[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonAssessmentCancelled( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonAssessmentCancelled = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4105' : 'UHN#3988' )  
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonAssessmentCancelled && reasonAssessmentCancelled[ 0 ] ) {
        return _.get( reasonAssessmentCancelled[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonRecipientNotEligible( patientBundle, organ ) {  
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonRecipientNotEligible = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4106' : 'UHN#3989' )
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonRecipientNotEligible && reasonRecipientNotEligible[ 0 ] ) {
        return _.get( reasonRecipientNotEligible[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getReasonFurtherTreatment( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let reasonRecipientNotEligible = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4107' : 'UHN#3990' ) 
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( reasonRecipientNotEligible && reasonRecipientNotEligible[ 0 ] ) {
        return _.get( reasonRecipientNotEligible[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getOther( patientBundle, organ ) { 
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let other = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === ( organ === 'Pancreas' ? 'UHN#4108' : 'UHN#3991' ) 
       && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( other && other[ 0 ] ) {
        return _.get( other[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getAbsoluteContraindication( patientBundle, organ ) {  
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
        let MED_ABS_CONTRAIND_CODE = 'UHN#3602';

      if ( organ === 'Liver' ) {
        MED_ABS_CONTRAIND_CODE = 'UHN#3787';
      } else if ( organ === 'Lung' ) {
        MED_ABS_CONTRAIND_CODE = 'UHN#3771';
      } else if ( organ === 'Heart' ) {
        MED_ABS_CONTRAIND_CODE = 'UHN#3790';
      } else if ( organ === 'Pancreas' ) {
        MED_ABS_CONTRAIND_CODE = 'UHN#3806';
      } else if ( organ === 'Intestine' ) {
        MED_ABS_CONTRAIND_CODE = 'UHN#3808';
      }
      if( observation && observation[ 0 ] ) {
      let absoluteContraindication = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === MED_ABS_CONTRAIND_CODE
      && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( absoluteContraindication && absoluteContraindication[ 0 ] ) {
        return _.get( absoluteContraindication[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getRelativeContraindication( patientBundle, organ ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
       let MED_REL_CONTRAIND_CODE = 'UHN#3603';
      if ( organ === 'Lung' ) {
        MED_REL_CONTRAIND_CODE = 'UHN#3772';
      } else if ( organ === 'Heart' ) {
        MED_REL_CONTRAIND_CODE = 'UHN#3791';
      } else if ( organ === 'Pancreas' ) {
        MED_REL_CONTRAIND_CODE = 'UHN#3807';
      }
      if( observation && observation[ 0 ] ) {
        let relativeContraindication = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === MED_REL_CONTRAIND_CODE && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( relativeContraindication && relativeContraindication[ 0 ] ) {
        return _.get( relativeContraindication[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
      let comments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#293' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) ) ;
      if( comments && comments[ 0 ] ) {
        return _.get( comments[0], 'resource.component[0].valueString' );
      } 
      }
    },
    getFirstName( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let firstName = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3977' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( firstName && firstName[0] ) {
          return _.get( firstName[0], 'resource.component[0].valueString' );
        }
      }
    },
    getLastName( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let lastName = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3978' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( lastName && lastName[0] ) {
          return _.get( lastName[0], 'resource.component[0].valueString' );
        }
      }
    },
    getAddress( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let lastName = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3979' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( lastName && lastName[0] ) {
          return _.get( lastName[0], 'resource.component[0].valueString' );
        }
      }
    },
    getCity( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let lastName = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3980' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( lastName && lastName[0] ) {
          return _.get( lastName[0], 'resource.component[0].valueString' );
        }
      }
    },
    getCountry( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let country = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3982' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( country && country[0] ) {
          return _.get( country[0], 'resource.component[0].valueString' );
        }
      }
    },
    getPostalCode( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let country = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3981' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( country && country[0] ) {
          return _.get( country[0], 'resource.component[0].valueString' );
        }
      }
    },
    getState( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if ( observation && observation[0] ) {
        let country = observation[0].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'UHN#3983' && _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if ( country && country[0] ) {
          return _.get( country[0], 'resource.component[0].valueString' );
        }
      }
    },
  },
};
</script>

<style scoped>

/* .card {
  height: 1350px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 2050px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.inputDisplayTransplantProgram {
  border-style: solid;
  width: 350px;
  background-color: #F2F2F2;
}

.inputDisplayOtherOrganizationType {
  border-style: solid;
  width: 350px;
  background-color: #F2F2F2;
}

.inputDisplayreferralDecisionReason {
  border-style: solid;
  width: 350px;
  background-color: #F2F2F2;
}

.inputDisplayreferralDecisionComments {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayreasonCancelled {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayreasonDelayed {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayconsultationComments{
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayassessmentDecision{
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplaycareTeamID{
  border-style: solid;
  width: 430px;
  background-color: #F2F2F2;
}

.inputDisplayreasonAssessmentCancelled {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayreasonRecipientNotEligible {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayother {
  border-style: solid;
  width: 450px;
  background-color: #F2F2F2;
}

.inputDisplaycomments {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.inputDisplayrelativeContraindication {
  border-style: solid;
  width: 300px;
  background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 12.5px;
  padding-bottom: 2.5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.mandatory-field label::after) {
  content: " *";
  color: red;
}

:deep(.transplantProgram .afflo-ds-form-control) {
  width: 400px;
} 

:deep(.otherOrganizationType .afflo-ds-form-control) {
  width: 350px;
}

:deep(.careTeamID .afflo-ds-form-control) {
  width: 460px;
}  

:deep(.referralDecisionReason .afflo-ds-form-control) {
  width: 310px;
} 

:deep(.primaryTransplantPhysician .afflo-ds-form-control) {
  width: 350px;
}

:deep(.consultationComments .afflo-ds-form-control) {
  width: 400px;
} 

:deep(.assessmentDecision .afflo-ds-form-control) {
  width: 420px;
} 

:deep(.primaryDiagnosis .afflo-ds-form-control) {
  width: 580px;
}

:deep(.referralDecision .afflo-ds-form-control) {
  width: 410px;
}

:deep(.address .afflo-ds-form-control) {
  width: 450px;
} 

:deep(.reasonAssessmentCancelled .afflo-ds-form-control) {
  width: 330px;
}

:deep(.other .afflo-ds-form-control) {
  width: 420px;
} 

:deep(.relativeContraindication .afflo-ds-form-control) {
  width: 380px;
}

:deep(.comments .afflo-ds-form-control) {
  width: 330px;
}

:deep(.consultationDecision .afflo-ds-form-control) {
  width: 320px;
}

:deep(.referringOrganizationName .afflo-ds-form-control) {
  width: 390px;
}

:deep(.reasonDelayed .afflo-ds-form-control) {
  width: 350px;
}

  :deep(.referringHealthCareProfessionalType .afflo-ds-form-control) {
    width: 400px;
  }

  :deep(.reasonRecipientNotEligible .afflo-ds-form-control) {
    width: 400px;
  }





</style>
